<template>
    <d-row class="mr-3">
        <div>
            <span> Export report via mail </span>
            <span class="btn btn-secondary mr-3" v-on:click.prevent="exportFunnelReport('csv')">
                <i class="fa">&#xf0e0;</i><span class="ml-1 d-none d-sm-inline-block"> .csv file </span>
            </span>
            <span class="btn btn-secondary" v-on:click.prevent="exportFunnelReport('xlsx')">
                <i class="fa">&#xf0e0;</i><span class="ml-1 d-none d-sm-inline-block"> .xlsx file</span>
            </span>
        </div>
    </d-row>
</template>

<script>
    import {AnalysisService} from '@/main';
    import DateHelper from '@/helpers/date';
    import notification from '@/mixins/notification'
    import loader from '@/mixins/loader'
    import * as Sentry from "@sentry/browser"

    export default {
        props: ['startDate', 'endDate', 'websiteId'],

        mixins: [notification, loader],

        methods: {
            async exportFunnelReport(format) {
                try {
                    await AnalysisService.exportFunnelReport(format, DateHelper.formatDate(this.startDate), DateHelper.formatDate(this.endDate), this.websiteId);

                    this.$swal({
                        title: "Success",
                        icon: "success",
                        text: `Your report will be mailed within few minutes`
                    })
                } catch (e) {
                    Sentry.captureException(e);

                    this.$swal({
                        title: "Oops",
                        icon: "error",
                        text: "Can not download report"
                    })

                    console.error(e)
                }
            }
        }
    }
</script>
